module.exports = __webpack_public_path__ + "img/laywer.3215c878.png";